import UnitView from './unit-view'

export default UnitView
